export default "__VITE_ASSET__25b9e2da__"